import { useState, useEffect, useCallback, useRef } from 'react';
import api from '../services/api';

const INTERVALO_MS = 45000;

const temToken = () => Boolean(localStorage.getItem('token'));

export default function useNotificacoes() {
  const [contagem, setContagem] = useState(0);
  const [itens, setItens] = useState([]);
  const [carregando, setCarregando] = useState(false);
  const [erro, setErro] = useState(null);
  const intervaloRef = useRef(null);

  const atualizarContagem = useCallback(async () => {
    if (!temToken()) return;
    try {
      const resposta = await api.getContagemNotificacoes();
      setContagem(resposta?.naoLidas || 0);
    } catch {
      /* polling em background falha em silêncio */
    }
  }, []);

  const carregarLista = useCallback(async () => {
    if (!temToken()) return;
    setCarregando(true);
    setErro(null);
    try {
      const lista = await api.getNotificacoes();
      setItens(Array.isArray(lista) ? lista : []);
      atualizarContagem();
    } catch {
      setErro('Não foi possível carregar as notificações.');
    } finally {
      setCarregando(false);
    }
  }, [atualizarContagem]);

  const marcarLida = useCallback(async (id) => {
    try {
      await api.marcarNotificacaoLida(id);
      setItens((prev) => prev.map((n) => (n.id === id ? { ...n, lida: true } : n)));
      atualizarContagem();
    } catch {
      /* silencioso */
    }
  }, [atualizarContagem]);

  const marcarTodas = useCallback(async () => {
    try {
      await api.marcarTodasNotificacoesLidas();
      setItens((prev) => prev.map((n) => ({ ...n, lida: true })));
      setContagem(0);
      setErro(null);
    } catch {
      setErro('Não foi possível marcar todas como lidas.');
    }
  }, []);

  useEffect(() => {
    const iniciar = () => {
      if (intervaloRef.current || document.hidden || !temToken()) return;
      atualizarContagem();
      intervaloRef.current = setInterval(atualizarContagem, INTERVALO_MS);
    };
    const parar = () => {
      if (intervaloRef.current) {
        clearInterval(intervaloRef.current);
        intervaloRef.current = null;
      }
    };
    const aoMudarVisibilidade = () => {
      if (document.hidden) parar();
      else iniciar();
    };

    iniciar();
    document.addEventListener('visibilitychange', aoMudarVisibilidade);
    return () => {
      parar();
      document.removeEventListener('visibilitychange', aoMudarVisibilidade);
    };
  }, [atualizarContagem]);

  return { contagem, itens, carregando, erro, carregarLista, marcarLida, marcarTodas };
}
